import { IMyMillUnitItem, MyMillUnitItem } from '@/models/myMill/MyMillUnitItem';

export interface IDexieMyMillUnitItem extends IMyMillUnitItem {
    id?: number;
}

export class DexieMyMillUnitItem extends MyMillUnitItem implements IDexieMyMillUnitItem {
    public id?: number;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDexieMyMillUnitItem);
    constructor(obj?: any) {
        super(obj && obj as IMyMillUnitItem);
        if (obj && obj.id != null) {
            this.id = obj && obj.id;
        }
    }
}
